import * as CookieConsent from "vanilla-cookieconsent";
import "@orestbida/iframemanager";
import "@orestbida/iframemanager/dist/iframemanager.css";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'
const SERVICE_YOUTUBE = 'youtube'
const SERVICE_VIMEO = 'vimeo'
const SERVICE_META = 'meta'

// Replace this with your own SVG icon markup
const FLOATING_BUTTON_ICON = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-75 29-147t81-128.5q52-56.5 125-91T475-881q21 0 43 2t45 7q-9 45 6 85t45 66.5q30 26.5 71.5 36.5t85.5-5q-26 59 7.5 113t99.5 56q1 11 1.5 20.5t.5 20.5q0 82-31.5 154.5t-85.5 127q-54 54.5-127 86T480-80Zm-60-480q25 0 42.5-17.5T480-620q0-25-17.5-42.5T420-680q-25 0-42.5 17.5T360-620q0 25 17.5 42.5T420-560Zm-80 200q25 0 42.5-17.5T400-420q0-25-17.5-42.5T340-480q-25 0-42.5 17.5T280-420q0 25 17.5 42.5T340-360Zm260 40q17 0 28.5-11.5T640-360q0-17-11.5-28.5T600-400q-17 0-28.5 11.5T560-360q0 17 11.5 28.5T600-320ZM480-160q122 0 216.5-84T800-458q-50-22-78.5-60T683-603q-77-11-132-66t-68-132q-80-2-140.5 29t-101 79.5Q201-644 180.5-587T160-480q0 133 93.5 226.5T480-160Zm0-324Z"/></svg>`;

/**
 * Show a static floating button in the corner that reopens the preferences modal.
 * Controlled by the "Reopen button" setting in the plugin's admin page.
 */
function renderFloatingButton() {
    if (!GrandcookieData.floatingButtonEnabled) return;
    if (document.getElementById('grand-cookie-floating-btn')) return;

    const button = document.createElement('button');
    button.id = 'grand-cookie-floating-btn';
    button.type = 'button';
    button.setAttribute('aria-label', 'Cookie settings');
    button.innerHTML = FLOATING_BUTTON_ICON;
    button.addEventListener('click', () => window.GrandCookie.showPreferences());

    document.body.appendChild(button);
}

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Set default consent to 'denied' (this should happen before changing any other dataLayer)
gtag('consent', 'default', {
    [SERVICE_AD_STORAGE]: 'denied',
    [SERVICE_AD_USER_DATA]: 'denied',
    [SERVICE_AD_PERSONALIZATION]: 'denied',
    [SERVICE_ANALYTICS_STORAGE]: 'denied',
    [SERVICE_FUNCTIONALITY_STORAGE]: 'denied',
    [SERVICE_PERSONALIZATION_STORAGE]: 'denied',
    [SERVICE_SECURITY_STORAGE]: 'denied',
});

/**
 * Update gtag consent according to the users choices made in CookieConsent UI
 */
function updateGtagConsent() {

    // Gtag consent
    if (typeof gtag !== 'undefined') gtag('consent', 'update', {
        [SERVICE_ANALYTICS_STORAGE]: window.GrandCookie.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
        [SERVICE_AD_STORAGE]: window.GrandCookie.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_USER_DATA]: window.GrandCookie.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_PERSONALIZATION]: window.GrandCookie.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_FUNCTIONALITY_STORAGE]: window.GrandCookie.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_PERSONALIZATION_STORAGE]: window.GrandCookie.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_SECURITY_STORAGE]: window.GrandCookie.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
    });

    // Meta pixel consent, in case if pixel is not handled by tag manager
    if (typeof fbq !== 'undefined') fbq('consent', window.GrandCookie.acceptedService(SERVICE_META, CAT_ANALYTICS) ? 'grant' : 'revoke');
}

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

let defaultSettings = {

    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 2,


    cookie: {
        name: 'grand-cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        // expiresAfterDays: 365,
    },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'cloud',
            position: 'bottom center',
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
            flipButtons: false
        }
    },

    // Configure categories and services
    categories: {
        [CAT_NECESSARY]: {
            enabled: true,  // this category is enabled by default
            readOnly: true,  // this category cannot be disabled
        },
        [CAT_ANALYTICS]: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    },
                    {
                        name: '_fbp',
                    }
                ]
            },
            // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                [SERVICE_ANALYTICS_STORAGE]: {},
                [SERVICE_META]: {},
                [SERVICE_YOUTUBE]: {
                    onAccept: () => window.GrandCookieIM.acceptService(SERVICE_YOUTUBE),
                    onReject: () => window.GrandCookieIM.rejectService(SERVICE_YOUTUBE)
                },
                [SERVICE_VIMEO]: {
                    onAccept: () => window.GrandCookieIM.acceptService(SERVICE_VIMEO),
                    onReject: () => window.GrandCookieIM.rejectService(SERVICE_VIMEO)
                },
            }
        },
        [CAT_ADVERTISEMENT]: {
            services: {
                [SERVICE_AD_STORAGE]: {},
                [SERVICE_AD_USER_DATA]: {},
                [SERVICE_AD_PERSONALIZATION]: {},
            }
        },
        [CAT_FUNCTIONALITY]: {
            services: {
                [SERVICE_FUNCTIONALITY_STORAGE]: {},
                [SERVICE_PERSONALIZATION_STORAGE]: {},
            }
        },
        [CAT_SECURITY]: {
            services: {
                [SERVICE_SECURITY_STORAGE]: {},
            }
        }
    },

    onFirstConsent: ({cookie}) => {
        // console.log('[Event] onFirstConsent fired',cookie);
        logConsent();
        updateGtagConsent()
    },

    onConsent: ({cookie}) => {
        // console.log('[Event] onConsent fired!', cookie)
        updateGtagConsent()
        renderFloatingButton();
    },

    onChange: ({changedCategories, changedServices}) => {
        // console.log('[Event] onChange fired!', changedCategories, changedServices);
        updateGtagConsent();
        logConsent();
    },

    onModalReady: ({modalName}) => {
        // console.log('[Event] ready:', modalName);
    },

    onModalShow: ({modalName}) => {
        // console.log('[Event] visible:', modalName);
    },

    onModalHide: ({modalName}) => {
        // console.log('[Event] hidden:', modalName);
    },
}

let imSettings = {
    onChange: ({ changedServices, eventSource }) => {
        if(eventSource.type === 'click') {
            const servicesToAccept = [
                ...window.GrandCookie.getUserPreferences().acceptedServices['analytics'],
                ...changedServices
            ];

            window.GrandCookie.acceptService(servicesToAccept, 'analytics');
        }
    },

    currLang: GrandcookieData.lang,

    services: {
        youtube: {
            embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
            thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',

            iframe: {
                allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
            },

            languages: {
                en: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
                    loadAllBtn: 'Accept and Load',
                },
                lv: {
                    notice: 'Šo saturu mitina trešā puse. Rādot ārējo saturu, jūs piekrītat vietnes youtube.com <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">pakalpojumu sniegšanas noteikumiem</a>.',
                    loadAllBtn: 'Pieņemt un ielādēt',
                },
                ru: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
                    loadAllBtn: 'Accept and Load',
                },
                de: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
                    loadAllBtn: 'Accept and Load',
                },
            },
            },

        vimeo: {
            embedUrl: 'https://player.vimeo.com/video/{data-id}',
            iframe: {
                allow: 'fullscreen; picture-in-picture;',
            },

            thumbnailUrl: async (dataId, setThumbnail) => {
                const url = `https://vimeo.com/api/v2/video/${dataId}.json`;
                const response = await (await fetch(url)).json();
                const thumbnailUrl = response[0]?.thumbnail_large;
                thumbnailUrl && setThumbnail(thumbnailUrl);
            },

            languages: {
                en: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://vimeo.com/terms" target="_blank">terms and conditions</a> of vimeo.com.',
                    loadAllBtn: 'Accept and Load',
                },
                lv: {
                    notice: 'Šo saturu mitina trešā puse. Parādot ārējo saturu, jūs piekrītat vietnes vimeo.com <a rel="noreferrer noopener" href="https://vimeo.com/terms" target="_blank">pakalpojumu sniegšanas noteikumiem</a>.',
                    loadAllBtn: 'Pieņemt un ielādēt',
                },
                ru: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://vimeo.com/terms" target="_blank">terms and conditions</a> of vimeo.com.',
                    loadAllBtn: 'Accept and Load',
                },
                de: {
                    notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://vimeo.com/terms" target="_blank">terms and conditions</a> of vimeo.com.',
                    loadAllBtn: 'Accept and Load',
                },
            },
        },
    },
};

window.GrandCookie = CookieConsent
window.GrandCookieIM = iframemanager();

// Fetch config and translations
Promise.all([
    GrandcookieData.config.settings ? fetch(GrandcookieData.config.settings).then(response => response.json()) : Promise.resolve({}),
    GrandcookieData.config ? Object.entries(GrandcookieData.config).reduce((p, [lang, url]) => {
        if (GrandcookieData.lang === lang) {
            return p.then(data => fetch(url).then(res => res.json()).then(newData => ({...data, ...newData})));
        }
        return p;
    }, Promise.resolve({})).then(translations => {
        if (Object.keys(translations).length === 0 && GrandcookieData.config.en) {
            return fetch(GrandcookieData.config.en).then(res => res.json());
        }
        return translations;
    }) : Promise.resolve({}),
]).then(async ([fileSettings, translations]) => {
    // Replace any placeholders in the JSON with the actual values
    const replacedFileSettings = handlePlaceholders(fileSettings);
    const replacedTranslations = handlePlaceholders(translations);

    // Merge the replaced data with the default settings
    const mergedSettings = {
        ...defaultSettings,  // Spread the default settings
        ...replacedFileSettings,  // Overwrite with any settings from the JSON
        language: {
            ...replacedFileSettings.language,
            translations: {
                [GrandcookieData.lang]: {
                    ...replacedTranslations
                }
            }
        }
    };

    // Merge service translations to corresponding categories
    Object.entries(replacedTranslations?.services ?? {}).forEach(([key, value]) => {
        Object.entries(mergedSettings.categories).forEach(([categoryKey, category]) => {
            if (category.services && category.services[key]) {
                mergedSettings.categories[categoryKey].services[key] = {
                    ...category.services[key],
                    ...value
                };
            }
        });
    });

    // Run
    await window.GrandCookie.run(mergedSettings)
    window.GrandCookieIM.run(imSettings);

    window.dispatchEvent(new Event('GrandCookieReady'));
}).catch(error => {
    console.error('Error loading JSON:', error);
});

function handlePlaceholders(input) {
    let data = JSON.parse(
        JSON.stringify(input)
            .replace(/{{hostname}}/g, location.hostname)
            .replace(/{{cookiesPolicyLink}}/g, GrandcookieData.cookiesUrl ? GrandcookieData.cookiesUrl : (console.warn('Cookies URL is undefined'), ''))
            .replace(/{{privacyPolicyLink}}/g, GrandcookieData.privacyUrl ? GrandcookieData.privacyUrl : (console.warn('Privacy URL is undefined'), ''))
            .replace(/{{cat_necessary}}/g, CAT_NECESSARY)
            .replace(/{{cat_analytics}}/g, CAT_ANALYTICS)
            .replace(/{{cat_advertisement}}/g, CAT_ADVERTISEMENT)
            .replace(/{{cat_functionality}}/g, CAT_FUNCTIONALITY)
            .replace(/{{cat_security}}/g, CAT_SECURITY)
    );

    // Add theme
    if (data.theme) {
        const themeStyles = Object.entries(data.theme).map(
            ([prop, value]) => `--cc-${prop}: ${value};`
        ).join(' ');
        const themeStyle = document.createElement('style');
        themeStyle.innerHTML = `#cc-main { ${themeStyles} }`;
        document.head.appendChild(themeStyle);

        // Remove theme from mergedSettings
        delete data.theme;
    }

    return data;
}
function logConsent(){
    // Retrieve all the fields
    const cookie = window.GrandCookie.getCookie();
    const preferences = window.GrandCookie.getUserPreferences();
    const userConsent = {
        nonce: GrandcookieData.nonce,
        action: 'save_cookie_consent',
        data: JSON.stringify({
            consentId: cookie.consentId,
            acceptType: preferences.acceptType,
            acceptedCategories: preferences.acceptedCategories,
            rejectedCategories: preferences.rejectedCategories,
            cookieRevision: cookie.revision,
            cookieExpiry: cookie.expirationTime,
        })
    };

    fetch(GrandcookieData.ajaxUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams(userConsent)
    });
}